// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
<div style="height: 100%">
  <v-toolbar dark dense  class="obspanel-toolbar">
    <v-btn icon to="/p/users/profile">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
  </v-toolbar>

  <v-container fluid style="height: 100%">
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="text-h5 mb-0">Change Password</h3>
        </div>
      </v-card-title>
      <v-progress-circular v-if="modifyPasswordInProgress" indeterminate v-bind:size="50" style="position: absolute; left: 0; right: 0; margin-left: auto; margin-right: auto; margin-top: 60px;"></v-progress-circular>
      <v-card-text>
        <form action="">
          <v-text-field name="email" label="Email" disabled :value="$store.state.noctuaSky.user.email" type="email" autocomplete="email"></v-text-field>
          <v-text-field required name="password" label="Current password" autocomplete="current-password" v-model="currentPassword" type="password"></v-text-field>
          <v-text-field required name="new-password" label="New password" autocomplete="new-password" v-model="newPassword" type="password" counter :rules="[rules.password]"></v-text-field>
          <v-text-field required name="new-password2" label="Confirm new password" autocomplete="new-password" v-model="newPassword2" type="password" :rules="[rules.confirmPassword]"></v-text-field>
        </form>
        <v-alert error v-model="showChangePasswordErrorAlert">{{ changePasswordErrorAlert }}</v-alert>
        <v-row justify="space-around">
          <v-btn @click.stop.native="changePassword()" :disabled="!formValid">Send</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>

</div>
</template>

<script>
import NoctuaSkyClient from '../../noctuasky-client'

export default {
  data: function () {
    return {
      modifyPasswordInProgress: false,
      changePasswordErrorAlert: '',
      currentPassword: '',
      newPassword: '',
      newPassword2: '',

      rules: {
        password: (value) => {
          if (value === '') {
            return true
          }
          if (value.length < 8) {
            return 'Use at least 8 characters'
          }
          return true
        },
        confirmPassword: (value) => {
          if (value === '') {
            return true
          }
          if (value !== this.newPassword) {
            return 'Passwords don\'t match'
          }
          return true
        }
      }
    }
  },
  methods: {
    changePassword: function () {
      var that = this
      this.modifyPasswordInProgress = true
      NoctuaSkyClient.users.changePassword(this.currentPassword, this.newPassword).then(res => {
        that.$router.go(-1)
        that.modifyPasswordInProgress = false
      }).catch(function (res) {
        that.modifyPasswordInProgress = false
        if (res.message) {
          that.changePasswordErrorAlert = res.message
        } else if (res.errors) {
          that.changePasswordErrorAlert = ''
          for (const k in res.errors) {
            that.changePasswordErrorAlert += k + ': ' + res.errors[k] + '\n'
          }
        }
      })
    }
  },
  computed: {
    formValid: function () {
      return this.currentPassword !== '' && this.newPassword.length > 5 && this.newPassword === this.newPassword2
    },
    showChangePasswordErrorAlert: function () {
      return this.changePasswordErrorAlert !== ''
    }
  }
}
</script>

<style>
</style>
